export enum BmarkFixingTileColor {
  HCO, // Active -> bg_red1
  SCO, // Active -> bg_yellow1
  TODAY, // Active -> bg_gray2
  FUTURE, // Active -> bg_gray5
  COMPLETED, // Active and Recent -> bg_green2
  ACTIVE, // Recent -> bg_red2
  FWD_PENDING, // Recent - Turquoise
}

export namespace BmarkFixingTileColor {
  let elements = [
    BmarkFixingTileColor.HCO,
    BmarkFixingTileColor.SCO,
    BmarkFixingTileColor.TODAY,
    BmarkFixingTileColor.FUTURE,
    BmarkFixingTileColor.COMPLETED,
    BmarkFixingTileColor.ACTIVE,
    BmarkFixingTileColor.FWD_PENDING,
  ];
  let alias = "com.bcdfx.model.BmarkFixingTileColor";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
